import { ISearchingTag, TagName, TagType } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import i18n from "src/app/shared/localization/i18n";

export const REQUESTED_NUMBER_OF_CHATS: number = 15;
export const TRIGGER_SCROLL_HEIGHT: number = 100;
export const SEARCHING_TAGS: ISearchingTag[] = [
    { 
        id: 1,
        tagName: TagName.Date,
        value: i18n.t('common.date'),
        suggestions: ["2", "3", "4"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 2,
        value: "=",
        tagType: TagType.OperationTag,
    },
    {
        id: 3,
        value: "!=",
        tagType: TagType.OperationTag,
    },
    {
        id: 4,
        tagName: TagName.Date,
        value: "",
        suggestions: [
            i18n.t('common.today'),
            i18n.t('common.yesterday'),
            i18n.t('common.currentWeek'),
            i18n.t('common.currentMonth'),
            i18n.t('common.currentYear'),
            i18n.t('common.period')
        ],
        tagType: TagType.ClosingTag,
    },
    {
        id: 5,
        tagName: TagName.Channel,
        value: i18n.t('common.channelType'),
        suggestions: ["2", "3", "6"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 6,
        tagName: TagName.Channel,
        value: "",
        suggestions: [
            i18n.t('channels.instagram'),
            i18n.t('channels.facebook'),
            i18n.t('channels.telegram'),
            i18n.t('channels.viber'),
            i18n.t('channels.vk'),
            i18n.t('channels.weChat'),
            i18n.t('channels.widget'),
            i18n.t('channels.uniformWidget'),
            i18n.t('channels.whatsApp'),
            i18n.t('channels.ednaWhatsApp'),
            i18n.t('channels.voiceChannel'),
            i18n.t('channels.telegramPrivate'),
            i18n.t('channels.sendPulse'),
        ],
        tagType: TagType.ClosingTag,
    },
    {
        id: 7,
        tagName: TagName.ChannelName,
        value: i18n.t('common.channelName'),
        suggestions: ["2", "3", "8"],
        tagType: TagType.OpeningTag
    },
    {
        id: 8,
        tagName: TagName.ChannelName,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag
    },
    {
        id: 9,
        tagName: TagName.Operator,
        value: i18n.t('channels.operator'),
        suggestions: ["2", "3", "10"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 10,
        tagName: TagName.Operator,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
    },
    {
        id: 11,
        tagName: TagName.OperatorType,
        value: i18n.t("common.operatorType"),
        suggestions: ["2", "3", "12"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 12,
        tagName: TagName.OperatorType,
        value: "",
        suggestions: [
            i18n.t('operators.operatorTypeOperator'),
            i18n.t('operators.operatorTypeBot'),
            i18n.t('operators.operatorTypeSupervisor'),
            i18n.t('operators.operatorTypeHuman'),
            i18n.t('operators.operatorTypeQueue'),
        ],
        tagType: TagType.ClosingTag,
    },
    {
        id: 13,
        tagName: TagName.Contact,
        value: i18n.t("common.contact"),
        suggestions: ["2", "3", "14"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 14,
        tagName: TagName.Contact,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
    },
    {
        id: 21,
        tagName: TagName.ChatType,
        value: i18n.t("common.chatType"),
        suggestions: ["2", "3", "22"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 22,
        tagName: TagName.ChatType,
        value: "",
        suggestions: [
            i18n.t('chat.chatTypePrivate'),
            i18n.t('chat.chatTypeGroup'),
            i18n.t('chat.chatTypeComment'),
            i18n.t('chat.chatTypeMailing'),
        ],
        tagType: TagType.ClosingTag,
    },
    {
        id: 15,
        tagName: TagName.Status,
        value: i18n.t('common.status'),
        suggestions: ["2", "3", "16"],
        tagType: TagType.OpeningTag
    },
    {
        id: 16,
        tagName: TagName.Status,
        value: "",
        suggestions: [
            i18n.t('chats.missed'),
            i18n.t('chats.expired'),
            i18n.t('chats.finished'),
        ],
        tagType: TagType.ClosingTag
    },
    {
        id: 17,
        tagName: TagName.ChatNumber,
        value: i18n.t('chats.chatNumber'),
        suggestions: ["2", "18"],
        tagType: TagType.OpeningTag,
    },
    {
        id: 18,
        tagName: TagName.ChatNumber,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag
    },
    {
        id: 25,
        tagName: TagName.Phone,
        value: i18n.t('contact.phoneNumber'),
        suggestions: ["2", "3", "26"],
        tagType: TagType.OpeningTag
    },
    {
        id: 26,
        tagName: TagName.Phone,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
    },
    {
        id: 27,
        tagName: TagName.MessengerNickname,
        value: i18n.t('contact.messengerNickname'),
        suggestions: ["2", "3", "28"],
        tagType: TagType.OpeningTag
    },
    {
        id: 28,
        tagName: TagName.MessengerNickname,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
    },
    {
        id: 23,
        tagName: TagName.MessengerExternalId,
        value: i18n.t('common.messengerExternalId'),
        suggestions: ["2", "24"],
        tagType: TagType.OpeningTag
    },
    {
        id: 24,
        tagName: TagName.MessengerExternalId,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag,
    },
    {
        id: 19,
        tagName: TagName.ChatTag,
        value: i18n.t('common.chatTag'),
        suggestions: ["2", "3", "20"],
        tagType: TagType.OpeningTag
    },
    {
        id: 20,
        tagName: TagName.ChatTag,
        value: "",
        suggestions: [],
        tagType: TagType.ClosingTag
    },
]